import React from 'react';
import {IconNext,IconBack} from '../../images/index';

const ControlButton = ({
    indexProgress = 0,
    totalPages = 0,
    decrement = () => '',
    handleSubmit = () => ''
}) => {
    const css = ``;

    const textNext = (indexProgress == 2) ? "Solicitar    " : "Siguiente    ";

    const cssControlButton = (index) => {
        switch (index) {
            case 0: return "control-button-ca-only mt-30 mb-30";
            case 3: return "display-none";//return "control-button-soa-only"//return "display-none";
            default: return "control-button-ca mt-30 mb-30";
        }
    }
    return (
        <div className={cssControlButton(indexProgress)}>
            {indexProgress !== 0 && <button tabindex="-1"
                className={`control-button-btn-ca prev-ca`}
                type="button"
                onClick={decrement}> <IconBack width={12} /> Volver </button>
            }
            {
                <button tabindex="-1"
                    className="control-button-btn-ca next-ca"
                    type="button"
                    onClick={handleSubmit}>
                     {textNext}  
                    {indexProgress <= totalPages && <IconNext width={12} />}
                </button>
            }
        </div>
    );
}

export { ControlButton };
